export default __webpack_public_path__ + "static/media/Snd_03.40fb0ba3.mp3";